import React, { Component, PropTypes } from 'react';
import styled from 'styled-components';
import Breakpoint from '../../utils/breakpoints';
import FloatingStickyHeader from './FloatingStickyHeader';

import { ProfileHeader } from '../../features/dashboard/containers';

const DefaultHeadera = styled.div`
  position: relative;
  height: ${props => (props.type === 'driver' ? '120px' : '160px')};
  width: 100%;
  background: ${props =>
    props.type === 'driver'
      ? props.theme.dashboard.driver
      : props.theme.dashboard.vehicle};
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  overflow: hidden;
`;

class DashboardHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      minimalMode: false
    };
  }

  floatingHeaderCallBack = minimalMode => {
    this.setState({
      minimalMode
    });
  };

  render() {
    const { details } = this.props;
    const { minimalMode } = this.state;

    return (
      <Breakpoint name="desktop">
        <FloatingStickyHeader
          variant={details.dashboardType === 'driver' ? 'secondary' : 'primary'}
          callBack={this.floatingHeaderCallBack}
        >
          <ProfileHeader {...details} minimalMode={minimalMode} />
        </FloatingStickyHeader>
        <DefaultHeadera type={details.dashboardType}>
          <ProfileHeader {...details} minimalMode={minimalMode} />
        </DefaultHeadera>
      </Breakpoint>
    );
  }
}
DashboardHeader.propTypes = {
  details: PropTypes.object
};

export default DashboardHeader;



// WEBPACK FOOTER //
// ./src/layouts/fleet/DashboardHeader.js